export default __webpack_public_path__ + "static/media/main-bg-item4.a86b8a78.png";